import React from 'react';
import AuthorizedPage from './AuthorizedPage';
import TransactionDayContainer from '../containers/TransactionDayContainer';


const TransactionDayPage = () => (
    <AuthorizedPage>
        <TransactionDayContainer />
    </AuthorizedPage>
);

export default TransactionDayPage;


// WEBPACK FOOTER //
// ./src/pages/TransactionDayPage.js